import * as Sentry from '@sentry/react';
import PropTypes from 'prop-types';
import React from 'react';

import { propTypesDataTakeAwayParagraph } from './TakeAwayParagraph.proptypes';

import * as S from './TakeAwayParagraph.styles';

export const TakeAwayParagraphSlice = ({ slice }) => {
  if (!slice) {
    return null;
  }

  const data = slice.primary || {};
  const { takeaway_slice_id: id, takeaway_content: content } = data || '';

  if (!content) {
    Sentry.captureMessage(
      'Error: missing required data in TakeAwayParagraph slice'
    );
    return null;
  }

  return (
    <S.Wrapper>
      <S.TakeawayParagraph id={id}>{content}</S.TakeawayParagraph>
    </S.Wrapper>
  );
};

TakeAwayParagraphSlice.propTypes = {
  /**
   * Content of the TakeAwayParagraph slice.
   */
  slice: PropTypes.shape(propTypesDataTakeAwayParagraph),
};
